import { motion } from "framer-motion";
import { HOW_IT_WORKS } from "../data/siteData";

export const HowItWorks = () => {
  return (
    <section
      id="how"
      data-testid="how-it-works-section"
      className="py-24 md:py-32 bg-brand-sage/30"
    >
      <div className="container-app">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-32">
            <p className="overline mb-4">A Simple Path</p>
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-brand-forest tracking-tight">
              How we work, step by step.
            </h2>
            <p className="mt-6 text-lg text-brand-muted leading-relaxed">
              No paperwork mountains. No 90-minute sales calls. Just a clear,
              human process from first contact to final signature.
            </p>
          </div>

          <div className="lg:col-span-8 space-y-6">
            {HOW_IT_WORKS.map((step, i) => (
              <motion.div
                key={step.n}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.6, delay: i * 0.15 }}
                data-testid={`step-${step.n}`}
                className="group relative bg-brand-cream border border-brand-line rounded-md p-8 md:p-10 hover:border-brand-forest transition-colors"
              >
                <div className="flex items-start gap-6">
                  <div className="flex-shrink-0">
                    <span className="font-heading text-5xl md:text-6xl font-bold text-brand-gold leading-none">
                      {step.n}
                    </span>
                  </div>
                  <div className="flex-1 pt-1">
                    <h3 className="font-heading text-xl md:text-2xl font-semibold text-brand-forest">
                      {step.title}
                    </h3>
                    <p className="mt-3 text-base text-brand-muted leading-relaxed">
                      {step.body}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
